import { ReactElement } from 'react'

import { SkatConnectionContextProvider } from '@features/vatDeclarations/contexts/skatConnectionContext'

import { VatDeclarationsContextProvider } from './context/vatDeclarationsContext'
import { VatDeclarationsRouteProvider } from './context/vatDeclarationsRouteContext'
import { VatDeclarationsList } from './elements/VatDeclarationsList'

export const VatDeclarations = (): ReactElement => {
  return (
    <VatDeclarationsRouteProvider>
      <VatDeclarationsContextProvider>
        <SkatConnectionContextProvider>
          <VatDeclarationsList />
        </SkatConnectionContextProvider>
      </VatDeclarationsContextProvider>
    </VatDeclarationsRouteProvider>
  )
}
